import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-status-student',
  templateUrl: './report-status-student.component.html',
  styleUrls: ['./report-status-student.component.scss']
})
export class ReportStatusStudentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
